
export const imageTypes = [".jpeg",".jpg",".png"]
export const validateDateKeyArr = ["date_of_manufacture","date_of_check"]

